import TicketConstants from "../Constants/TicketConstants";
import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";

let resultValue = null;

class TicketStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }
  getResult() {
    return resultValue;
  }

  setResult(result) {
    resultValue = result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case TicketConstants.GET_TICKET_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.GET_TICKET_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_TICKET_STATUS_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_TICKET_STATUS_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_TICKET_STATUS_DETAIL_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_TICKET_STATUS_DETAIL_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_PUBLIC_TICKET_STATUS_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_PUBLIC__TICKET_STATUS_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_MUL_TICKET_STATUS_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.UPDATE_MUL_TICKET_STATUS_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.GET_TICKET_DETAILS_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.GET_TICKET_DETAILS_FAILURE:
        this.setResult(action.result);
        break;
      case TicketConstants.GET_EQUIPMENT_TICKET_SUCCESS:
        this.setResult(action.result);
        break;
      case TicketConstants.GET_EQUIPMENT_TICKET_FAILURE:
        this.setResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const ticketStore = new TicketStore();
dispatcher.register(ticketStore.handleCallback.bind(ticketStore));
export default ticketStore;
